import type {Story, Timeline} from "~/types/story";

export const createEmptyTimeline = (overrides: Partial<Timeline> = {}): Timeline => {
    return {
        year: '',
        title: '',
        content: '',
        ...overrides
    }
}

export const createEmptyStory = (overrides: Partial<Story> = {}): Story => {
    return {
        uuid: null,
        firstName: '',
        lastName: '',
        email: '',
        gender: 'Unspecified',
        header: '',
        quote: '',
        content: '',
        birthDate: '',
        deathDate: '',
        language: 'en',
        mainPhotoUrl: '',
        photoUrls: [],
        template: 'Template1',
        timeline: [],
        unlimited: false,
        creationDate: new Date().toISOString(),
        lastModifiedDate: new Date().toISOString(),
        validUntilDate: '',
        ...overrides
    }
}